<script>
import TablePage from '../../../../components/table_page';
import Form from '../../../process/components/process_approve/approve.vue';

export default {
  extends: TablePage,
  components: {
    Form,
  },
  data() {
    return {
      tablePage: {
        pageSize: 8,
      },
      configs: {
        pagination: false,
        tableConfig: {
          border: 'inner',
        },
      },
      params: {
        orderStatus: '3',
        pageNum: 1,
        pageSize: 15,

      },
      isCalculateHeight: false,
    };
  },
  created() {
    this.getConfigList('member_order_list');
  },
  methods: {
    modalClick({ val, row }) {
      if (val.code === 'view') {
        this.$router.push({ path: '/membercenter/cashOrder' });
      }
    },
  },
};
</script>
